import gql from 'graphql-tag';

export const EDIT_SAVED_SEARCH = gql`
    mutation editSavedSearch($input: SearchFields!) {
        updateSavedSearch(input: $input) {
            status
            statusText
            body
        }
    }
`;

export const CREATE_SAVED_SEARCH = gql`
    mutation createSavedSearch($input: SearchFields!) {
        createNewSavedSearch(input: $input) {
            status
            statusText
            body
        }
    }
`;
